import { render } from "./TagsMap.vue?vue&type=template&id=823fdd9a&ts=true"
import script from "./TagsMap.vue?vue&type=script&lang=ts"
export * from "./TagsMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__